import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { useHotkeys } from "react-hotkeys-hook";
import { T } from "services/lang/LanguageService";
import { copyToClipBoard } from "../utils/clipboard";

const useCopyDataset = (isHovered: boolean, title: string | undefined, identifier: string | undefined) => {
  useHotkeys(
    "ctrl+c",
    async () => {
      if (isHovered && title) {
        await copyToClipBoard(title);
        easasAlert({ summary: T("alert.copied-dataset-tag"), detail: title, life: 2500 });
      }
    },
    [title, isHovered]
  );

  useHotkeys(
    "alt+c",
    async () => {
      if (isHovered && identifier) {
        await copyToClipBoard(identifier);
        easasAlert({ summary: T("alert.copied-identifier"), detail: `${identifier}`, life: 2500 });
      }
    },
    [identifier, isHovered]
  );
};

export default useCopyDataset;
